import translation from './i18n-index'
import { I18n } from '../I18n'
const lang = 'es-mx'
const $i18n = new I18n(translation[lang].default)
export default () => {
  return $i18n
}
